import type { CMYKColor } from "#public"
import type { RGBColor } from "#public"
import type { ColorComponent } from "#public"

import { Max } from "../math/Math"

/**
 * Converts RGB color to CMYK color
 * Assumes RGB values are in range 0-1
 */
export const RgbToCmyk = ({ alpha, blue, green, red }: RGBColor): CMYKColor => {
  // Calculate key (black)
  const black = (1 - Max(red, green, blue)) as ColorComponent

  // Avoid division by zero
  if (black === 1) {
    return {
      alpha,
      cyan: 0 as ColorComponent,
      black: 1 as ColorComponent,
      magenta: 0 as ColorComponent,
      yellow: 0 as ColorComponent,
    }
  }

  // Calculate the CMY components
  const cyan = ((1 - red - black) / (1 - black)) as ColorComponent
  const magenta = ((1 - green - black) / (1 - black)) as ColorComponent
  const yellow = ((1 - blue - black) / (1 - black)) as ColorComponent

  return { alpha, cyan, black, magenta, yellow }
}
